import React, { useState, useContext, useCallback, useEffect } from "react";
import { LandingZoneModel } from "@api";
import { Form, UPDATE_FILTERS_DATA } from "@components";
import { TableContext } from "../table";
import { LandingZoneDetail } from "../../../screens/dashboard/admin/maintenance/landingzones/detail";
import { Box, Grid } from "@material-ui/core";
import { Actions } from "../../../screens/request/components/actions";
import { Search } from "./search-filters";

export const LandingZonesToolbar: React.FC = () => {
  const [openLandingZone, setOpenLandingZone] = useState<boolean>(false);
  const { dispatch } = useContext(TableContext);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  const form = Form.useManager<LandingZoneModel>({
    id: 0,
    name: "",
    isActive: false,
    approver2: "",
    approver3: "",
    approver4: "",
    approverDistro2Id: 0,
    approverDistro2Name: "",
    approverDistro3Id: 0,
    approverDistro3Name: "",
    approverDistro4Id: 0,
    approverDistro4Name: "",
    businessUnitId: 0,
    businessUnitName: "",
    assignmentTeam: "",
    accessDetailNote: "",
    uamNote: "",
    metadata: "",
  });

  useEffect(() => {
    if (!openLandingZone) {
      form.reset();
    }
  }, [openLandingZone]);

  function handleClickOpen() {
    setOpenLandingZone(true);
  }

  const isShowModal = openLandingZone ? (
    <LandingZoneDetail
      form={form}
      open={openLandingZone}
      onCancel={() => setOpenLandingZone(false)}
    />
  ) : null;

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Landing Zone
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Name"}
          ></Search>
        </Grid>
      </Grid>
      {isShowModal}
    </Box>
  );
};
